/** @jsxImportSource @emotion/react **/
import React, { FC, useContext, useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Select from "react-select";

import { LANG_ALL, styleContainer } from '../../../pages/utils';
import { Context } from '../../../context/FaqsContext'
import { BaseInput, Text, TextareaInput } from '../../atoms'
import { ContentSection } from '../../organisms'
import * as styles from "../Header/index.styles";


const FaqsForm: FC = () => {
  const { formData, handleChangeFormData: handleChange, handleUpdateFormData: handleData } = useContext(Context)
  let { id } = useParams();
  const detail_data = useSelector((state: any) => state.get_faqs.data)
  const news_data = id ? detail_data?.data.find((r: any) => r.id === id) : null

  useEffect(() => {
    if (!!id) {
      handleData(news_data)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, news_data])

  const langInit = news_data?.lang ? { value: news_data.lang, label: news_data.lang } : { value: '', label: '' }
  const [isTitleValid, setTitleValid] = useState<boolean>(false)
  const [isHrefValid, setHrefValid] = useState<boolean>(false)

  useEffect(() => {
    setTitleValid(formData.question.length > 2)
  }, [formData.question])

  useEffect(() => {
    setHrefValid(formData.answer.length > 0)
  }, [formData.answer])

  const handleLang = (e: any) => {
    handleChange({ lang: e.value })
  }

  return (
    <ContentSection
      style={styleContainer}
      header={
        <React.Fragment>
          <Text textType='h4' weight='black'>{id ? 'Editar' : 'Nuevo'} Pregunta Frecuente</Text>
        </React.Fragment>
      }
    >
      <BaseInput
        label='Pregunta'
        value={formData.question}
        onChange={(value) => handleChange({ question: value })}
        placeholder='Escribe tu pregunta'
        maxLength={500}
        error={!isTitleValid && formData.question.length > 0}
        success={isTitleValid}
        hint={!isTitleValid && formData.question.length > 0 ? 'Digite mas de dos letras' : ''}
      />
      <TextareaInput
        label='Respuesta'
        value={formData.answer}
        onChange={(value) => handleChange({ answer: value })}
        placeholder='Escribe tu respuesta'
        maxLength={500}
        error={!isHrefValid && formData.answer.length > 0}
        success={isHrefValid}
        hint={!isHrefValid && formData.answer.length > 0 ? 'Digite mas de una letra' : ''}
      />
      <Text textType="label">
        IDIOMA :{' '}
        <Select css={styles.input}
          options={LANG_ALL}
          defaultValue={langInit}
          onChange={(e) => handleLang(e)}
        />
      </Text>
      {/* <SwitchInput
        checked={formData.isActive}
        onCheckedChange={(value) => handleChange({ isActive: value })}
        label={formData.isActive ? 'Activo' : 'Inactivo'}
      /> */}

    </ContentSection>
  )
}

export default FaqsForm
